import React from "react";

import { ProgressBarWidgetIconProps } from "../../../../types/widgets";

export const ProgressBarWidget3 = (props: ProgressBarWidgetIconProps) => (
  <svg
    width={300}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke={props.activebarcolor || "#E0E0E0"}
      strokeWidth={4}
      strokeLinecap="round"
      d="M18.609 14.572h67.627"
    />
    <path
      stroke={props.inactivebarcolor || "#E0E0E0"}
      strokeWidth={4}
      strokeLinecap="round"
      d="M122.418 14.572h67.626M213.766 14.572h67.626"
    />
    <path fill="#fff" d="M1.035 15.533h12.457V27.99H1.035z" />
    <circle
      cx={104.326}
      cy={13.976}
      r={6.747}
      fill={props.breakpointactive || "#E0E0E0"}
    />
    <circle
      cx={201.904}
      cy={13.976}
      r={6.747}
      fill={props.breakpointinactive || "#E0E0E0"}
    />
    <circle
      cx={293.251}
      cy={13.976}
      r={6.747}
      fill={props.breakpointinactive || "#E0E0E0"}
    />
    <circle
      cx={6.747}
      cy={13.976}
      r={6.747}
      fill={props.breakpointactive || "#E0E0E0"}
    />
    <path
      d="M96.176 5.804c-.271.27-.527.547-.766.832l.383.322a10.782 10.782 0 0 0-1.225 1.792l-.44-.239c-.363.67-.652 1.372-.867 2.105l.48.14c-.2.683-.332 1.394-.396 2.134l-.498-.043a12.954 12.954 0 0 0 0 2.257l.498-.043c.064.74.197 1.45.397 2.13l-.48.141c.215.732.505 1.432.87 2.1l.438-.239c.34.625.749 1.22 1.225 1.788l-.383.322a12.897 12.897 0 0 0 1.595 1.594l.321-.383c.568.475 1.164.882 1.788 1.22l-.239.44c.669.363 1.368.652 2.098.867l.141-.48c.682.2 1.391.333 2.128.398l-.044.498a12.842 12.842 0 0 0 2.256 0l-.043-.498c.74-.064 1.451-.197 2.133-.396l.14.48a10.752 10.752 0 0 0 2.105-.865l-.239-.44c.627-.339 1.225-.747 1.793-1.222l.321.383c.285-.239.563-.494.833-.765h.001c.269-.271.522-.549.76-.834l-.385-.32c.473-.569.879-1.166 1.216-1.79l.44.237a10.74 10.74 0 0 0 .863-2.1l-.48-.14c.199-.68.331-1.39.396-2.128l.498.044a12.707 12.707 0 0 0 0-2.255l-.498.044a11.076 11.076 0 0 0-.395-2.132l.48-.14a10.82 10.82 0 0 0-.86-2.103l-.441.237a10.814 10.814 0 0 0-1.216-1.794l.384-.32a12.45 12.45 0 0 0-1.597-1.598l-.321.384a10.78 10.78 0 0 0-1.793-1.219l.237-.44c-.67-.36-1.371-.648-2.104-.86l-.14.48a11.032 11.032 0 0 0-2.132-.394l.043-.498a13.008 13.008 0 0 0-2.253 0l.043.498c-.739.064-1.448.196-2.128.394l-.14-.48c-.731.213-1.43.5-2.099.862l.239.44c-.625.338-1.22.744-1.788 1.218l-.32-.383c-.285.237-.563.49-.833.76Zm0 0 .353.354-.353-.354Zm11.994 20.569a12.55 12.55 0 0 1-2.545.511l-.047-.498c-.41.04-.827.06-1.251.06a.503.503 0 0 0-.079.006c-.393-.003-.78-.022-1.163-.059l-.048.498a12.368 12.368 0 0 1-2.528-.511l.15-.477a11.58 11.58 0 0 1-1.16-.434l-.001-.001a13.596 13.596 0 0 1-1.09-.529l-.238.44a13.105 13.105 0 0 1-2.08-1.399l.317-.386a12.422 12.422 0 0 1-1.705-1.704l-.386.318a13.017 13.017 0 0 1-1.399-2.08l.44-.239a13.41 13.41 0 0 1-.528-1.089 11.78 11.78 0 0 1-.43-1.162l-.478.15a12.478 12.478 0 0 1-.508-2.529l.498-.047a12.946 12.946 0 0 1 0-2.491l-.497-.049c.085-.87.254-1.722.508-2.543l.478.147c.123-.397.266-.787.43-1.17.161-.373.337-.734.526-1.083l-.439-.24c.403-.741.869-1.432 1.398-2.07l.385.318a12.133 12.133 0 0 1 1.708-1.692l-.316-.387a13.318 13.318 0 0 1 2.08-1.391l.239.44c.35-.19.712-.367 1.087-.53a11.95 11.95 0 0 1 1.161-.432l-.149-.477a12.468 12.468 0 0 1 2.527-.512l.049.497a12.755 12.755 0 0 1 2.49 0l.049-.497c.87.084 1.722.255 2.544.508l-.148.478c.398.123.788.266 1.169.43.373.16.734.336 1.083.525l.239-.44c.741.403 1.432.868 2.071 1.393l-.318.386a12.398 12.398 0 0 1 1.696 1.696l.386-.318c.525.639.989 1.33 1.392 2.071l-.44.239c.19.349.365.71.527 1.083.165.383.31.773.434 1.169l.477-.15c.256.821.427 1.67.511 2.545l-.498.048a12.862 12.862 0 0 1 .001 2.493l.498.048a12.178 12.178 0 0 1-.511 2.528l-.476-.15a11.72 11.72 0 0 1-.436 1.16v.001a13.73 13.73 0 0 1-.528 1.088l.44.238a13.28 13.28 0 0 1-1.393 2.08l-.387-.316a12.526 12.526 0 0 1-1.692 1.708l.319.385c-.639.529-1.33.995-2.072 1.398l-.238-.44c-.35.19-.712.366-1.085.527-.383.166-.773.31-1.169.434l.149.478Z"
      stroke={props.breakpointactive || "#E0E0E0"}
      strokeLinejoin="round"
      strokeDasharray="2 2"
    />
  </svg>
);
